// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__AccountConfirmationPopup__headerunderline{text-decoration:underline}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ent-capability-billing-react/AccountConfirmationPopup/AccountConfirmationPopup.module.scss"],"names":[],"mappings":"AAAA,gDACI,yBAAA","sourcesContent":[".headerunderline{\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerunderline": "app__AccountConfirmationPopup__headerunderline"
};
export default ___CSS_LOADER_EXPORT___;
